<template>
  <button type="button" @click="close"><slot /></button>
</template>

<script>
import { DialogEventBus } from '@js/eventBus';

export default {
  props: {
    targetId: {
      type: String,
      required: true,
    },
  },
  methods: {
    close() {
      DialogEventBus.$emit('dialog-closed', { targetId: this.targetId });
    },
  },
};
</script>
